<template>
  <b-card class="rounded-xl">
    <div class="flex  justify-between  items-center">
      <div>
        <h2 class="text-2xl font-semibold">
          My Account
        </h2>
      </div>
      <base-button outline type="success" class="flex">
        Transaction History
      </base-button>
    </div>

    <div class="py-4">
      <div class="flex cust-shadow mt-6">
        <div class="w-1/4 bg-cyan rounded-l-lg">
          <div class="text-white px-6 py-10">
            <p class="font-bold text-3xl">Free Plan</p>
            <p class="font-md text-lg">E-commerce</p>

            <a
              class="badge badge-pill badge-secondary bg-rocket mt-2 flex w-180px p-0"
            >
              <!-- <feather-icon icon="AwardIcon" class="text-white"></feather-icon> -->
              <img
                src="./img/success.png"
                alt="hello"
                class="w-7 my-auto h-7"
              />
              <a class=" my-auto text-black font-bold text-xs pl-2">
                Upgrade Plan</a
              >
            </a>
          </div>
        </div>
        <div class="w-2/4 p-6">
          <div class="flex">
            <div class="w-1/2">
              <div
                class="flex mt-1 justify-center"
                v-for="(item, index) in 4"
                :key="index"
              >
                <img src="./img/tick.png" alt="hello" class="w-3 my-auto h-3" />
                <p class="ml-1 text-md font-semibold">Account Security</p>
              </div>
            </div>
            <div class="w-1/2">
              <div
                class="flex mt-1 justify-center"
                v-for="(item, index) in 2"
                :key="index"
              >
                <img src="./img/tick.png" alt="hello" class="w-3 my-auto h-3" />
                <p class="ml-1 text-md font-semibold">Account Security</p>
              </div>
            </div>
          </div>
        </div>
        <div class="w-1/4 bg-ededed rounded-r-lg flex items-center text-center">
          <div class="text-black font-semibold w-full text-xl">
            INR 5000 / Mo
          </div>
        </div>
      </div>
    </div>
    <el-table
      class="table-responsive table-flush mt-6"
      header-row-class-name="thead-light table-th-color"
      :data="TagsData"
    >
      <el-table-column
        label="Extensions"
        prop="extension"
        min-width="180px"
        sortable
      >
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.extension }}</span>
        </template>
      </el-table-column>
      <el-table-column label="Active" min-width="100px" prop="active" sortable>
        <template>
          <div class="flex items-center">
            <div
              class="flex items-center cursor-pointer"
              data-toggle="tooltip"
              data-placement="top"
              title="Edit"
            >
              <label class="custom-toggle mb-0">
                <input type="checkbox" checked />
                <span
                  class="custom-toggle-slider rounded-circle"
                  data-label-off="Yes"
                  data-label-on="No"
                ></span>
              </label>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="Price (INR)" min-width="100px" prop="price">
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.price }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Status" prop="status" min-width="140px" sortable>
        <template v-slot="{ row }">
          <span class=" text-black font-medium">{{ row.status }}</span>
        </template>
      </el-table-column>

      <el-table-column label="Action" prop="status" min-width="140px">
        <template v-slot="{ row }">
          <span class="badge badge-default text-black px-3 py-2">{{
            row.action
          }}</span>
        </template>
      </el-table-column>
    </el-table>
  </b-card>
</template>
<script>
import TagsData from "./components/TagsData";
import EditTagsDetail from "./components/EditTagsDetail";
import AddTagsSidebar from "./components/AddTagsSidebar";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    EditTagsDetail,
    AddTagsSidebar
  },
  data() {
    return {
      TagsData,
      currentPage: 1,
      editModal: false,
      openAddBannerSidebar: false
    };
  },
  methods: {
    addBanner() {
      this.toggleAddBannerSidebar(true);
    },
    toggleAddBannerSidebar(val = false) {
      this.openAddBannerSidebar = val;
    }
  }
};
</script>
